"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.returnValues = returnValues;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _exifJs = _interopRequireDefault(require("exif-js"));

var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(returnValues);

var orientationNumbersToTurn = [6, 3, 8];

var ExifHelper = /*#__PURE__*/function () {
  function ExifHelper(file) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, ExifHelper);

    this.getRealMimeType = function (reader) {
      var arr = new Uint8Array(reader.result).subarray(0, 4);
      var header = '';
      var realMimeType = null;

      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      switch (header) {
        case '89504e47':
          realMimeType = 'image/png';
          break;

        case '47494638':
          realMimeType = 'image/gif';
          break;

        case 'ffd8ffDB':
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
          realMimeType = 'image/jpeg';
          break;

        default:
          realMimeType = 'unknown'; // Or you can use the blob.type as fallback

          break;
      }

      return realMimeType;
    };

    this.convertFileBasedOnOrientation = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(orientation) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var canvas = document.createElement('canvas');
                  var context = null;
                  var tempImage = new window.Image();
                  var blob = new Blob([_this.buffer], {
                    type: _this.mimeType
                  });

                  tempImage.onload = function () {
                    var width = tempImage.width;
                    var height = tempImage.height;

                    if (orientation === 6) {
                      canvas.width = height;
                      canvas.height = width;
                      context = canvas.getContext('2d');
                      context.translate(height, 0);
                      context.rotate(90 * Math.PI / 180);
                      context.drawImage(tempImage, 0, 0, width, height);
                    }

                    if (orientation === 3) {
                      canvas.width = width;
                      canvas.height = height;
                      context = canvas.getContext('2d');
                      context.translate(width, height);
                      context.rotate(180 * Math.PI / 180);
                      context.drawImage(tempImage, 0, 0, width, height);
                    }

                    if (orientation === 8) {
                      canvas.width = height;
                      canvas.height = width;
                      context = canvas.getContext('2d');
                      context.translate(0, width);
                      context.rotate(270 * Math.PI / 180);
                      context.drawImage(tempImage, 0, 0, width, height);
                    } // returns file


                    canvas.toBlob(function (blob) {
                      return resolve(new window.File([blob], _this.file.name, {
                        type: _this.file.type
                      }));
                    }, _this.file.type); // resolve(canvas.toDataURL())

                    context = null;
                    canvas = null;
                  };

                  tempImage.src = window.URL.createObjectURL(blob);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.checkTheNeedForConversion = function (binaryExif) {
      return binaryExif && binaryExif.Orientation && orientationNumbersToTurn.includes(binaryExif.Orientation);
    };

    this.readOrientationFromBinary = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var fileBuffer, needConversion, convertedFile;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof _this.file.name !== 'string')) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", new Error('Not a File'));

            case 2:
              _context2.next = 4;
              return _this.getFileArrayBuffer();

            case 4:
              fileBuffer = _context2.sent;
              _this.exifData = _exifJs["default"].readFromBinaryFile(fileBuffer);
              needConversion = _this.checkTheNeedForConversion(_this.exifData);

              if (!needConversion) {
                _context2.next = 12;
                break;
              }

              _context2.next = 10;
              return _this.convertFileBasedOnOrientation(_this.exifData.Orientation);

            case 10:
              convertedFile = _context2.sent;
              return _context2.abrupt("return", convertedFile);

            case 12:
              return _context2.abrupt("return", _this.file);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    this.file = file;
    this.buffer = null;
    this.exifData = null;
  }

  (0, _createClass2["default"])(ExifHelper, [{
    key: "getFileArrayBuffer",
    value: function getFileArrayBuffer() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function () {
          _this2.buffer = reader.result;
          _this2.mimeType = _this2.getRealMimeType(reader);
          resolve(reader.result);
        };

        reader.readAsArrayBuffer(_this2.file);
      });
    }
  }]);
  return ExifHelper;
}();

function returnValues() {
  return _regenerator["default"].wrap(function returnValues$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return test;

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked);
}

var _default = ExifHelper;
exports["default"] = _default;